import {Component, DestroyRef, ElementRef, inject, OnInit, signal, ViewChild, WritableSignal} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatSelectChange} from '@angular/material/select';
import {Router} from '@angular/router';
import {faDatabase} from '@fortawesome/free-solid-svg-icons';
import {TranslateService} from '@ngx-translate/core';
import {GridComponent} from '@syncfusion/ej2-angular-grids';
import {first} from 'rxjs/operators';
import {BenutzerModels} from '../../models/benutzer-models';
import {ServiceAppModels} from '../../models/serviceapp-models';
import {SwissAppConfigModels} from '../../models/swissappconfig-models';
import {TimeSheetModels} from '../../models/timesheet-models';
import {MessageBoxService} from '../../services/message-box.service';
import {ServiceAppService} from '../../services/service-app.service';
import {SwissSettingsService} from '../../services/swiss-settings.service';
import {TimeSheetService} from '../../services/time-sheet.service';
import {LocalStorageService} from '../../local-storage.service';
import {SharedDataService} from '../services/shared-data.service';
import {VinavonUpdateService} from '../../services/vinavon-update.service';
import {MatDialog} from '@angular/material/dialog';
import {BackupService, ServerBackupInfo} from 'src/app/services/backup.service';
import {UserAuthenticationService} from '../../services/user-authentication.service';
import {HelperService} from '../../services/helper.service';
import {Device, DeviceDetectionService} from '../../services/device-detection-service';
import {environment} from 'src/environments/environment';
import {from, tap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import UserLicenses = BenutzerModels.UserLicenses;
import {SwissInternModels} from '../../models/swissintern-models';
import StartSite = SwissInternModels.StartSite;

@Component({
    selector: 'app-settings', templateUrl: './settings.component.html', styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
    showSettings = false;
    @ViewChild('gridRechte') public gridRechte?: GridComponent;
    faDatabase = faDatabase;
    public offlineDaten: Object[] = [{
        id: 1, name: 'Mitarbeiter', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 2, name: 'Mitarbeitergruppen', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 3, name: 'Mandanten', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 4, name: 'Termine / Pendenzen', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 5, name: 'Dynamische Feldkonfigurationen', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 6, name: 'Adresstypen', hasChild: false, expanded: false, isChecked: true,
    },];
    public serviceAppDaten: Object[] = [{
        id: 1, name: 'Stammdaten', hasChild: true, expanded: false, isChecked: true,
    }, {id: 2, pid: 1, name: 'Mandanteninformationen / Adresse'}, {id: 3, pid: 1, name: 'Adresstypen'}, {id: 4, pid: 1, name: 'Benutzerrechte'}, {id: 5, pid: 1, name: 'Kostenstellen / Kostenstellenansätze'}, {id: 6, pid: 1, name: 'Spesen'}, {
        id: 7, pid: 1, name: 'Mitarbeiter / Mitarbeiteransätze'
    }, {id: 8, name: 'Produkte', hasChild: false, isChecked: true}, {id: 9, name: 'Objekte', hasChild: true, isChecked: true}, {id: 10, pid: 9, name: 'Aufträge'}, {id: 13, pid: 9, name: 'Adressen'}, {id: 14, pid: 9, name: 'Dokumente'}, {id: 15, pid: 9, name: 'Servicepositionen'}, {
        id: 16, name: 'Checkliste', hasChild: false, isChecked: true
    }, {id: 17, name: 'Dokumente', hasChild: false, isChecked: true},];
    // maps the appropriate column to fields property
    public fieldOffline: Object = {
        dataSource: this.offlineDaten, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild',
    };
    public fieldSA: Object = {
        dataSource: this.serviceAppDaten, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild',
    };
    // set the CheckBox to the TreeView
    public webUserConfig!: BenutzerModels.WebUserConfig;
    public sa_Config?: ServiceAppModels.SA_Config;
    public kostenstellen: TimeSheetModels.CostCenter[] = [];
    public sa_DefaultCostCenter?: TimeSheetModels.CostCenter;
    public anwender!: BenutzerModels.Anwender;
    public vinavonVersion: string = environment.version;
    /* Benutzerrechte */
    public dbBenutzerGruppen: BenutzerModels.BenutzerGruppe[] = [];
    public userHasGroups: boolean = false;
    public dataSourceBenutzerRechte: BenutzerModels.BenutzerRechtListElement[] = [];
    public sortOptions!: object;
    /* Kalendereinstellungen */
    public timeGridStart: string = '06:00';
    public timeGridEnd: string = '20:00';
    public timeWorkDayStart: string = '07:00';
    public timeWorkDayEnd: string = '19:00';
    public startPage?: number;
    public groupOptions?: Object = undefined;
    startSites: StartSite[] = [
        {value: 0, viewValue: ''},
        {value: 6, viewValue: 'Time-App'}
    ];
    public checked: boolean = false;
    public settingsForm = new UntypedFormGroup({
        language: new UntypedFormControl(''), deleteTimeEntryDays: new UntypedFormControl(''), defaultCostCenter: new UntypedFormControl('')
    });
    vinbkup: any;
    blockedInfo: string = '';
    backUpFileName: string = '';
    @ViewChild('vinbkupUpload') public vinbkupUpload?: ElementRef<HTMLElement>;
    @ViewChild('vinbkInput') public vinbkInput?: any;
    @ViewChild('vinbkApply') public vinbkApply?: any;
    blocked = false;
    public device: Device;
    private swissAppUserConfig?: SwissAppConfigModels.SwissAppUserConfig;
    private dbBenutzerRechte: BenutzerModels.BenutzerRecht[] = [];
    private destroyRef = inject(DestroyRef);
    public serverBackupInfo: WritableSignal<ServerBackupInfo | undefined> = signal(undefined);

    constructor(private router: Router,
                private localStorage: LocalStorageService,
                private shareDataService: SharedDataService,
                private translate: TranslateService,
                private svcSA: ServiceAppService,
                private svcMessageBox: MessageBoxService,
                private svcSwissSettings: SwissSettingsService,
                private svcTimeSheet: TimeSheetService,
                private userAuthService: UserAuthenticationService,
                protected helperService: HelperService,
                protected svcVinavonUpdate: VinavonUpdateService,
                public dialog: MatDialog,
                private backupService: BackupService,
                private deviceDetectionService: DeviceDetectionService) {
        this.webUserConfig = this.svcSwissSettings.getWebConfig();
        this.anwender = this.userAuthService.getCurrentAuthenticatedUser()!;
        this.device = this.deviceDetectionService.getDevice();
        this.sortOptions = {
            columns: [{field: 'OrderID', direction: 'Ascending'}, {field: 'ID', direction: 'Ascending'},],
        };
        this.helperService.setPageRefreshURL('/timeapp/settings').then(() => {
            if (this.userAuthService.getCurrentAuthenticatedUser() == undefined) {
                this.router.navigate(['login/']);
            }
        });

        from(this.userAuthService.hasLicences(UserLicenses.CNavigatorMobile)).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasLicence => {
            if (hasLicence) {
                this.startSites.push(
                    {value: 1, viewValue: 'Dashboard'},
                    {value: 2, viewValue: 'Adressen'},
                    {value: 3, viewValue: 'Objekte'},
                    {value: 4, viewValue: 'Pendenzen'}
                );
            }
        });

        from(this.userAuthService.hasLicences(UserLicenses.CServiceApp)).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasLicence => {
            if (hasLicence) {
                this.startSites.push({value: 5, viewValue: 'Service-App'});
            }
        });

        this.loadServerBackupInfo();
    }

    // #region Backup Functions
    get getPath() {
        return this.backUpFileName;
    }

    ngOnInit(): void {
        this.loadAppUserConfig();
        this.loadAppUserGroups();
        this.loadAppUserRights();
        this.loadServiceAppConfig();

        this.shareDataService.currentZeitTotal.pipe(first()).subscribe({
            next: (res: any) => {
                if (res) {
                    this.checked = res;
                }
            },
        });

        this.setDeleteTimeEntry();
        this.settingsForm.get('deleteTimeEntryDays')?.valueChanges.subscribe({
            next: (res) => {
                this.anwender = this.userAuthService.getCurrentAuthenticatedUser()!;
                this.anwender.sA_DeleteDataAfter = res;
            }
        });

        this.localStorage.get('DefaultCostCenterID', 'SwissWebConfigDB', false, this.anwender.costCenter).then(defaultCostCenterID => {
            this.settingsForm.get('defaultCostCenter')!.setValue(defaultCostCenterID);
            this.settingsForm.get('defaultCostCenter')?.valueChanges.subscribe({
                next: (res) => {
                    this.anwender = this.userAuthService.getCurrentAuthenticatedUser()!;
                    this.anwender.costCenter = res;
                    this.sa_DefaultCostCenter = res;
                    this.localStorage.add('DefaultCostCenterID', res, 'SwissWebConfigDB');
                }
            });
        });

        this.localStorage.get('language', 'SwissTimeEntry', true).then((res) => {
            if (!res) {
                this.settingsForm.get('language')?.setValue(res);
            }
            this.settingsForm.get('language')?.setValue(res);
        });

        this.settingsForm.get('language')?.valueChanges.subscribe({
            next: (res) => {
                this.translate.use(res);
                this.localStorage.add('language', res, 'SwissTimeEntry', false, true);
            },
        });
    }

    changeTimeTotal() {
        this.shareDataService.shareZeitTotal(!this.checked);
    }

    setDeleteTimeEntry() {
        this.settingsForm.get('deleteTimeEntryDays')?.setValue(this.anwender.sA_DeleteDataAfter);
    }

    ////////////////////////////////

    goBack() {
        this.router.navigate(['/timeapp']);
    }

    async loadAppUserConfig(): Promise<void> {
        this.svcSwissSettings.getSwissAppUserConfig$().pipe(
            takeUntilDestroyed(this.destroyRef),
            tap((userConfig) => {
                this.swissAppUserConfig = userConfig;
                this.timeGridStart = userConfig.timeGridStart;
                this.timeGridEnd = userConfig.timeGridEnd;
                this.timeWorkDayStart = userConfig.timeGridWorkDayStart;
                this.timeWorkDayEnd = userConfig.timeGridWorkDayEnd;
                this.startPage = userConfig.startPage;
            })
        ).subscribe();
    }

    loadAppUserGroups() {
        this.userAuthService.getUserGroups().then((value) => {
            if (value) {
                this.dbBenutzerGruppen = value;
                if (this.dbBenutzerGruppen.length > 0) {
                    this.userHasGroups = true;
                }
            }
        });
    }

    loadAppUserRights() {
        this.groupOptions = {columns: ['GroupOrder']};
        this.userAuthService.getUserRights().then((value) => {
            if (value) {
                this.dbBenutzerRechte = value;
                this.dataSourceBenutzerRechte = [];

                this.dbBenutzerRechte.forEach((br) => {
                    this.dataSourceBenutzerRechte.push({
                        ID: br.rightsID,
                        HatRecht: br.value,
                        HatGruppenRecht: br.groupValue,
                        HatEffektivRecht: br.effectiveValue,
                        Gruppe: br.rightsGrpText,
                        Rechtbeschreibung: br.rightsText,
                        Reihenfolge: br.textOrder,
                        OrderID: br.orderID,
                        GroupOrder: br.groupOrder,
                    });
                });
            }
        });
    }

    loadServiceAppConfig() {
        this.svcTimeSheet.getKostenstellen().subscribe({
            next: (res) => {
                if (res) {
                    this.kostenstellen = res;

                    if (this.anwender.costCenter) {
                        this.sa_DefaultCostCenter = this.kostenstellen.filter((c) => c.costCenterID == this.anwender.costCenter)[0];
                    }

                    this.svcSA.getCurrentSAConfig().subscribe({
                        next: (res2: ServiceAppModels.SA_Config | undefined) => {
                            if (res2) {
                                // Hier wird die serverseitige Konfiguration neu geladen. Diese hat Einfluss auf den Up- & Download.
                                this.sa_Config = res2;
                                this.sa_DefaultCostCenter = this.kostenstellen.filter((c) => c.costCenterID == this.sa_Config?.standardKostenstelle)[0];
                            }
                        }, error: (error: any) => {
                            console.error(error);
                            this.svcMessageBox.showError('Die Konfiguration der Service-App konnte nicht ermittelt werden!!', '!! FEHLER !!');
                        },
                    });
                }
            }, error: (error) => {
                console.error(error);
                this.svcMessageBox.showError('Die Kostenstellen konnten nicht ermittelt werden!!', '!! FEHLER !!');
            },
        });
    }

    dropdownStartPageChange(event: MatSelectChange) {
        this.swissAppUserConfig!.startPage = event.value;
        this.svcSwissSettings.setStartPage(event.value);
    }

    onGridStartChange(value?: any) {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            let wert = value.target.value;
            if (wert.length === 5) {
                this.timeGridStart = wert;
                this.svcSwissSettings.setTimeGrid(wert, this.timeGridEnd);
            }
            console.log('Grid Start', value.target.value);
        }
    }

    onGridEndChange(value?: any) {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            let wert = value.target.value;
            if (wert.length === 5) {
                this.timeGridEnd = wert;
                this.svcSwissSettings.setTimeGrid(this.timeGridStart, wert);
            }
            console.log('Grid End', value.target.value);
        }
    }

    onWorkDayStartChange(value?: any) {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            let wert = value.target.value;
            if (wert.length === 5) {
                this.timeWorkDayStart = wert;
                this.svcSwissSettings.setTimeGridWorkDay(wert, this.timeWorkDayEnd);
            }
            console.log('Grid WorkDay Start', value.target.value);
        }
    }

    onWorkDayEndChange(value?: any) {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            let wert = value.target.value;
            if (wert.length === 5) {
                this.timeWorkDayEnd = wert;
                this.svcSwissSettings.setTimeGridWorkDay(this.timeWorkDayStart, wert);
            }
            console.log('Grid WorkDay End', value.target.value);
        }
    }

    public startDBControl() {
        this.router.navigate(['dbcontrol-mobile']);
    }

    onChange(event: any) {
        var files = event.target?.files;

        if (files[0]) {
            if (this.backupService.acceptableFile(files[0]) && files.length == 1) {
                if (this.vinbkInput?.nativeElement) {
                    this.vinbkInput.nativeElement.files = files;
                    this.backUpFileName = files[0].name;
                    this.allowBKImport();
                }
            } else {
                this.disallowBKImport();
            }
        }
    }

    allowBKImport() {
        this.vinbkupUpload?.nativeElement.classList.add('acceptedFile');
        this.vinbkupUpload?.nativeElement.classList.remove('badFile');
        this.vinbkApply.nativeElement.classList.add('acceptedFile');
        this.vinbkApply.nativeElement.classList.remove('badFile');
    }

    disallowBKImport() {
        this.vinbkInput.nativeElement.value = '';
        this.vinbkupUpload?.nativeElement.classList.add('badFile');
        this.vinbkupUpload?.nativeElement.classList.remove('acceptedFile');
        this.vinbkApply?.nativeElement.classList.add('badFile');
        this.vinbkApply?.nativeElement.classList.remove('acceptedFile');
    }

    downloadBackup() {
        this.backupService.downloadBackUp();
    }

    async loadBackup() {
        await this.backupService.loadBackup(this.vinbkInput);
    }

    protected async setDebugMode(enabled: boolean): Promise<void> {
        this.webUserConfig.debugMode = enabled;
        // Einstellung wird sofort gespeichert
        await this.svcSwissSettings.updateWebUserConfig(this.webUserConfig);
    }

    downloadServerBackup(): void {
        this.backupService.downloadServerBackup();
    }

    restoreServerBackup(): void {
        this.backupService.restoreServerBackup();
    }

    private async loadServerBackupInfo(): Promise<void> {
        this.serverBackupInfo.set(await this.backupService.getServerBackupInfo());
    }
    // #endregion
}
